module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8u3c5"))).then(() => parcelRequire('hEqeo'));